<template>
  <h3 class="flex gap-2 mb-2.5">
    <base-icon name="vuesax-outline-star" size="w-5 h-5" />
    <span>{{ $t('top') }}</span>
  </h3>
  <p class="text-sm">{{ $t('favoritePortals.favoritesEmptyLegend') }}</p>
</template>
